module.exports = __webpack_public_path__ + "img/Empty.b58b682e.png";